var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "94",
        height: "158",
        viewBox: "0 0 94 158",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("circle", {
        attrs: {
          r: "28.2986",
          transform: "matrix(-1 0 0 1 45.7521 69.5418)",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "11.4556",
          height: "33.5485",
          transform: "matrix(-1 0 0 1 51.5515 14.7285)",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "16.3651",
          height: "4.90954",
          transform: "matrix(-1 0 0 1 54.0078 11.4551)",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M67.1959 60.9778H52.0818L40.9113 55.3926H27.5084C24.4727 59.3007 22.6652 64.2104 22.6652 69.5421C22.6652 82.292 33.001 92.6279 45.7509 92.6279C58.5008 92.6279 68.8367 82.292 68.8367 69.5421C68.8367 66.5161 68.2545 63.626 67.1959 60.9778Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "4.88974",
          height: "4.88974",
          transform: "matrix(-1 0 0 1 49.012 48.1279)",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "3.25982",
          height: "3.25982",
          transform: "matrix(-1 0 0 1 61.2344 53.0176)",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M53.9013 57.0928L47.7007 61.5977L50.0691 68.8869H57.7334L60.1018 61.5977L53.9013 57.0928Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M85.0984 157.105V23.7295H37.6395",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M52.1401 135.616H38.2329L31.2793 143.497V151.378H59.0938V143.497L52.1401 135.616Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "18.543",
          height: "3.70859",
          transform: "matrix(-1 0 0 1 54.457 131.907)",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M45.2149 107.802L35.9154 122.551L38.2823 131.908H45.739H52.2153L53.5313 117.537L47.0412 122.551L45.2149 107.802Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          y1: "-1",
          x2: "24.5477",
          y2: "-1",
          transform: "matrix(4.37115e-08 -1 -1 -4.37115e-08 84.2808 24.5479)",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M85.1001 19.6387L81.557 21.6843V25.7756L85.1001 27.8212L88.6433 25.7756V21.6843L85.1001 19.6387Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M85.1001 144.831L81.557 146.877V150.968L85.1001 153.014L88.6433 150.968V146.877L85.1001 144.831Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M57.2798 19.6387L53.7367 21.6843V25.7756L57.2798 27.8212L60.823 25.7756V21.6843L57.2798 19.6387Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M54.0039 21.6836H37.6388V25.7749H54.0039V21.6836Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "93.2812",
          height: "8.18257",
          transform: "matrix(-1 0 0 1 93.2812 148.923)",
          fill: "black"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }